import { defaultFormMessages } from "../../shared/crud/form";
import { defaultListMessages } from "../../shared/crud/list";
import { defineMessages } from "react-intl";

export const messages = {
  ...defaultFormMessages,
  ...defaultListMessages,
  ...defineMessages({
    title: {
      id: "loyalty.bulkUpdate.title",
      defaultMessage: "Loyalty bulk upgrade",
    },
    description: {
      id: "loyalty.bulkUpdate.description",
      defaultMessage: "To process the file, upload it and click Import",
    },
    import: {
      id: "loyalty.bulkUpdate.import",
      defaultMessage: "Import",
    },
    exportToExcel: {
      id: "loyalty.bulkUpdate.exportToExcel",
      defaultMessage: "Export",
    },
    dropHere: {
      id: "loyalty.bulkUpdate.dropHere",
      defaultMessage: "Drop file here...",
    },
  }),
};